module.exports = __webpack_public_path__ + "images/boost-icon-0c661078959e7e63b57c96630befeeb6.png";